import { render, staticRenderFns } from "./DeltaView.vue?vue&type=template&id=d50878da"
import script from "./DeltaView.vue?vue&type=script&lang=ts"
export * from "./DeltaView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d50878da')) {
      api.createRecord('d50878da', component.options)
    } else {
      api.reload('d50878da', component.options)
    }
    module.hot.accept("./DeltaView.vue?vue&type=template&id=d50878da", function () {
      api.rerender('d50878da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cards/comparison/DeltaView.vue"
export default component.exports